//! Common
export const SET_IS_LOADING = 'SET_IS_LOADING';
export const SET_SOCKET_CONNECTION_STATUS = 'SET_SOCKET_CONNECTION_STATUS';
export const OPEN_DOWNLOAD_OUR_APP_MODAL = 'OPEN_DOWNLOAD_OUR_APP_MODAL';
export const CLOSE_DOWNLOAD_OUR_APP_MODAL = 'CLOSE_DOWNLOAD_OUR_APP_MODAL';
export const WEB_LANGUAGE = 'WEB_LANGUAGE';

//! Auth
//* Customer Auth
export const IS_CUSTOMER_LOGIN_MODAL_OPEN = 'IS_CUSTOMER_LOGIN_MODAL_OPEN';
export const CUSTOMER_LOGIN = 'CUSTOMER_LOGIN';
export const CUSTOMER_LOGIN_OTP = 'CUSTOMER_LOGIN_OTP';
export const CUSTOMER_LOGIN_INPUT_FIELD = 'CUSTOMER_LOGIN_INPUT_FIELD';
export const CUSTOMER_UPDATE_PROFILE = 'CUSTOMER_UPDATE_PROFILE';
export const CUSTOMER_CHANGE_PICTURE = 'CUSTOMER_CHANGE_PICTURE';

//* Astrologer Auth
export const IS_ASTROLOGER_LOGIN_MODAL_OPEN = 'IS_ASTROLOGER_LOGIN_MODAL_OPEN';
export const ASTROLOGER_LOGIN = 'ASTROLOGER_LOGIN';

//* Logout 
export const USER_LOGOUT = 'USER_LOGOUT';

//! User 
export const GET_USER_CUSTOMER_BY_ID = 'GET_USER_CUSTOMER_BY_ID';
export const SET_USER_CUSTOMER_BY_ID = 'SET_USER_CUSTOMER_BY_ID';
export const RECHARGE_USER_CUSTOMER_WALLET = 'RECHARGE_USER_CUSTOMER_WALLET';
export const GET_USER_CUSTOMER_COMPLETED_QUEUE_LIST = 'GET_USER_CUSTOMER_COMPLETED_QUEUE_LIST';
export const SET_USER_CUSTOMER_COMPLETED_QUEUE_LIST = 'SET_USER_CUSTOMER_COMPLETED_QUEUE_LIST';
export const UPDATE_USER_CUSTOMER_COMPLETED_QUEUE_LIST_READ_STATUS = 'UPDATE_USER_CUSTOMER_COMPLETED_QUEUE_LIST_READ_STATUS';
export const GET_USER_CUSTOMER_WALLET_HISTORY = 'GET_USER_CUSTOMER_WALLET_HISTORY';
export const SET_USER_CUSTOMER_WALLET_HISTORY = 'SET_USER_CUSTOMER_WALLET_HISTORY';
export const GET_USER_CUSTOMER_TRANSACTION_HISTORY = 'GET_USER_CUSTOMER_TRANSACTION_HISTORY';
export const SET_USER_CUSTOMER_TRANSACTION_HISTORY = 'SET_USER_CUSTOMER_TRANSACTION_HISTORY';
export const GET_USER_CUSTOMER_ORDER_HISTORY = 'GET_USER_CUSTOMER_ORDER_HISTORY';
export const SET_USER_CUSTOMER_ORDER_HISTORY = 'SET_USER_CUSTOMER_ORDER_HISTORY';
export const GET_USER_CUSTOMER_PUJA_BOOK_HISTORY = 'GET_USER_CUSTOMER_PUJA_BOOK_HISTORY';
export const SET_USER_CUSTOMER_PUJA_BOOK_HISTORY = 'SET_USER_CUSTOMER_PUJA_BOOK_HISTORY';
export const GET_USER_CUSTOMER_ADDRESS = 'GET_USER_CUSTOMER_ADDRESS';
export const SET_USER_CUSTOMER_ADDRESS = 'SET_USER_CUSTOMER_ADDRESS';
export const CREATE_USER_CUSTOMER_ADDRESS = 'CREATE_USER_CUSTOMER_ADDRESS';
export const UPDATE_USER_CUSTOMER_ADDRESS = 'UPDATE_USER_CUSTOMER_ADDRESS';
export const DELETE_USER_CUSTOMER_ADDRESS = 'DELETE_USER_CUSTOMER_ADDRESS';

export const GET_USER_CUSTOMER_CONSULTATION_HISTORY = 'GET_USER_CUSTOMER_CONSULTATION_HISTORY';
export const SET_USER_CUSTOMER_CONSULTATION_HISTORY = 'SET_USER_CUSTOMER_CONSULTATION_HISTORY';

export const GET_USER_ASTROLOGER_BY_ID = 'GET_USER_ASTROLOGER_BY_ID';
export const SET_USER_ASTROLOGER_BY_ID = 'SET_USER_ASTROLOGER_BY_ID';
export const CHANGE_USER_ASTROLOGER_CHAT_STATUS = 'CHANGE_USER_ASTROLOGER_CHAT_STATUS';
export const CHANGE_USER_ASTROLOGER_CALL_STATUS = 'CHANGE_USER_ASTROLOGER_CALL_STATUS';
export const CHANGE_USER_ASTROLOGER_VIDEO_CALL_STATUS = 'CHANGE_USER_ASTROLOGER_VIDEO_CALL_STATUS';
export const USER_ASTROLOGER_WITHDRAWAL_REQUEST = 'USER_ASTROLOGER_WITHDRAWAL_REQUEST';
export const GET_USER_ASTROLOGER_PENDING_QUEUE_LIST = 'GET_USER_ASTROLOGER_PENDING_QUEUE_LIST';
export const SET_USER_ASTROLOGER_PENDING_QUEUE_LIST = 'SET_USER_ASTROLOGER_PENDING_QUEUE_LIST';
export const GET_USER_ASTROLOGER_COMPLETED_QUEUE_LIST = 'GET_USER_ASTROLOGER_COMPLETED_QUEUE_LIST';
export const SET_USER_ASTROLOGER_COMPLETED_QUEUE_LIST = 'SET_USER_ASTROLOGER_COMPLETED_QUEUE_LIST';
export const UPDATE_USER_ASTROLOGER_PENDING_QUEUE_LIST_STATUS = 'UPDATE_USER_ASTROLOGER_PENDING_QUEUE_LIST_STATUS';
export const GET_USER_ASTROLOGER_WALLET_HISTORY = 'GET_USER_ASTROLOGER_WALLET_HISTORY';
export const SET_USER_ASTROLOGER_WALLET_HISTORY = 'SET_USER_ASTROLOGER_WALLET_HISTORY';
export const GET_USER_ASTROLOGER_TRANSACTION_HISTORY = 'GET_USER_ASTROLOGER_TRANSACTION_HISTORY';
export const SET_USER_ASTROLOGER_TRANSACTION_HISTORY = 'SET_USER_ASTROLOGER_TRANSACTION_HISTORY';
export const GET_USER_ASTROLOGER_REGISTERED_PUJA_HISTORY = 'GET_USER_ASTROLOGER_REGISTERED_PUJA_HISTORY';
export const SET_USER_ASTROLOGER_REGISTERED_PUJA_HISTORY = 'GET_USER_ASTROLOGER_REGISTERED_PUJA_HISTORY';
export const GET_USER_ASTROLOGER_ASSIGNED_PUJA_HISTORY = 'GET_USER_ASTROLOGER_ASSIGNED_PUJA_HISTORY';
export const SET_USER_ASTROLOGER_ASSIGNED_PUJA_HISTORY = 'GET_USER_ASTROLOGER_ASSIGNED_PUJA_HISTORY';
export const GET_USER_ASTROLOGER_BOOKED_PUJA_HISTORY = 'GET_USER_ASTROLOGER_BOOKED_PUJA_HISTORY';
export const SET_USER_ASTROLOGER_BOOKED_PUJA_HISTORY = 'GET_USER_ASTROLOGER_BOOKED_PUJA_HISTORY';
export const COMPLETE_BOOKED_PUJA_HISTORY = 'COMPLETE_BOOKED_PUJA_HISTORY';

export const GET_USER_ASTROLOGER_CONSULTATION_HISTORY = 'GET_USER_ASTROLOGER_CONSULTATION_HISTORY';
export const SET_USER_ASTROLOGER_CONSULTATION_HISTORY = 'SET_USER_ASTROLOGER_CONSULTATION_HISTORY';

//* Consultation
export const GET_SLOT_DURATION = 'GET_SLOT_DURATION';
export const SET_SLOT_DURATION = 'SET_SLOT_DURATION';
export const CREATE_USER_ASTROLOGER_SLOTS = 'CREATE_USER_ASTROLOGER_SLOTS';
export const GET_USER_ASTROLOGER_SLOT_DATE = 'GET_USER_ASTROLOGER_SLOT_DATE';
export const SET_USER_ASTROLOGER_SLOT_DATE = 'SET_USER_ASTROLOGER_SLOT_DATE';
export const GET_USER_ASTROLOGER_SLOT_TIME_BY_DATE = 'GET_USER_ASTROLOGER_SLOT_TIME_BY_DATE';
export const SET_USER_ASTROLOGER_SLOT_TIME_BY_DATE = 'SET_USER_ASTROLOGER_SLOT_TIME_BY_DATE';
export const TOGGLE_USER_ASTROLOGER_SLOT_STATUS = 'TOGGLE_USER_ASTROLOGER_SLOT_STATUS';

//! Predefined Message
export const GET_USER_QUEUE_PREDEFINED_MESSAGE = 'GET_USER_QUEUE_PREDEFINED_MESSAGE';
export const SET_USER_QUEUE_PREDEFINED_MESSAGE = 'SET_USER_QUEUE_PREDEFINED_MESSAGE';

//! Astrologer
export const GET_LIVE_ASTROLOGER = 'GET_LIVE_ASTROLOGER';
export const SET_LIVE_ASTROLOGER = 'SET_LIVE_ASTROLOGER';
export const GET_ASTROLOGER = 'GET_ASTROLOGER';
export const SET_ASTROLOGER = 'SET_ASTROLOGER';
export const GET_ASTROLOGER_BY_ID = 'GET_ASTROLOGER_BY_ID';
export const SET_ASTROLOGER_BY_ID = 'SET_ASTROLOGER_BY_ID';
export const GET_ASTROLOGER_REVIEW_BY_ID = 'GET_ASTROLOGER_REVIEW_BY_ID';
export const SET_ASTROLOGER_REVIEW_BY_ID = 'SET_ASTROLOGER_REVIEW_BY_ID';
export const GET_ASTROLOGER_SKILL = 'GET_ASTROLOGER_SKILL';
export const SET_ASTROLOGER_SKILL = 'SET_ASTROLOGER_SKILL';
export const GET_ASTROLOGER_MAIN_EXPERTISE = 'GET_ASTROLOGER_MAIN_EXPERTISE';
export const SET_ASTROLOGER_MAIN_EXPERTISE = 'SET_ASTROLOGER_MAIN_EXPERTISE';
export const FOLLOW_UNFOLLOW_ASTROLOGER = 'FOLLOW_UNFOLLOW_ASTROLOGER';
export const GET_ASTROLOGER_FOLLOWED_STATUS_BY_CUSTOMER = 'GET_ASTROLOGER_FOLLOWED_STATUS_BY_CUSTOMER';
export const SET_ASTROLOGER_FOLLOWED_STATUS_BY_CUSTOMER = 'SET_ASTROLOGER_FOLLOWED_STATUS_BY_CUSTOMER';

//* Consultation
export const GET_ASTROLOGER_SLOT_DATE = 'GET_ASTROLOGER_SLOT_DATE';
export const SET_ASTROLOGER_SLOT_DATE = 'SET_ASTROLOGER_SLOT_DATE';
export const GET_ASTROLOGER_SLOT_TIME_BY_DATE = 'GET_ASTROLOGER_SLOT_TIME_BY_DATE';
export const SET_ASTROLOGER_SLOT_TIME_BY_DATE = 'SET_ASTROLOGER_SLOT_TIME_BY_DATE';
export const BOOK_CONSULTATION = 'BOOK_CONSULTATION';

// TODO : Consultation
export const JOIN_CONSULTATION_SESSION_BY_ASTROLOGER = 'JOIN_CONSULTATION_SESSION_BY_ASTROLOGER';
export const JOIN_CONSULTATION_SESSION_BY_CUSTOMER = 'JOIN_CONSULTATION_SESSION_BY_CUSTOMER';
export const SET_CONSULTATION_TIMER_COUNTDOWN = 'SET_CONSULTATION_TIMER_COUNTDOWN';
export const CLOSE_CONSULTATION_SESSION = 'CLOSE_CONSULTATION_SESSION';
export const GET_CURRENT_CONSULTATION_SESSION_DATA = 'GET_CURRENT_CONSULTATION_SESSION_DATA';
export const SET_CURRENT_CONSULTATION_SESSION_DATA = 'SET_CURRENT_CONSULTATION_SESSION_DATA';

// TODO : Chat
export const GET_LINKED_PROFILE_FOR_CHAT = 'GET_LINKED_PROFILE_FOR_CHAT';
export const SET_LINKED_PROFILE_FOR_CHAT = 'SET_LINKED_PROFILE_FOR_CHAT';
// export const CREATE_PROFILE_FOR_CHAT = 'CREATE_PROFILE_FOR_CHAT';
// export const INITIATE_CHAT_MESSAGE = 'INITIATE_CHAT_MESSAGE';
export const CHAT_REQUEST_SEND_BY_CUSTOMER = 'CHAT_REQUEST_SEND_BY_CUSTOMER';
export const CHAT_REQUEST_ACCEPT_REJECT_BY_ASTROLOGER = 'CHAT_REQUEST_ACCEPT_REJECT_BY_ASTROLOGER';
export const CHAT_REQUEST_ACCEPT_REJECT_BY_CUSTOMER = 'CHAT_REQUEST_ACCEPT_REJECT_BY_CUSTOMER';
export const SET_CHAT_TIMER_COUNTDOWN = 'SET_CHAT_TIMER_COUNTDOWN';
export const END_CHAT_MESSAGE = 'END_CHAT_MESSAGE';
export const CLOSE_CHAT_MESSAGE = 'CLOSE_CHAT_MESSAGE';
export const HIDE_CHAT_MESSAGE_INPUT_FIELD = 'HIDE_CHAT_MESSAGE_INPUT_FIELD';
export const SUGGEST_REMEDIES_DURING_CHAT = 'SUGGEST_REMEDIES_DURING_CHAT';

//* Rest 
export const SEND_CHAT_MESSAGE = 'SEND_CHAT_MESSAGE';
export const GET_CHAT_MESSAGE = 'GET_CHAT_MESSAGE';
export const SET_CHAT_MESSAGE = 'SET_CHAT_MESSAGE';

//* Chat Invoice 
export const GET_CHAT_INVOICE_DATA = 'GET_CHAT_INVOICE_DATA';
export const SET_CHAT_INVOICE_DATA = 'SET_CHAT_INVOICE_DATA';

export const GET_CHAT_INVOICE_VISIBILITY = 'GET_CHAT_INVOICE_VISIBILITY';
export const SET_CHAT_INVOICE_VISIBILITY = 'SET_CHAT_INVOICE_VISIBILITY';

export const GET_ASTROLOGER_CHAT_INVOICE_VISIBILITY = 'GET_ASTROLOGER_CHAT_INVOICE_VISIBILITY';
export const SET_ASTROLOGER_CHAT_INVOICE_VISIBILITY = 'SET_ASTROLOGER_CHAT_INVOICE_VISIBILITY';

// TODO : Call
export const CALL_INTAKE_DETAIL_DATA = 'CALL_INTAKE_DETAIL_DATA';

//* Call Invoice 
export const GET_CALL_INVOICE_DATA = 'GET_CALL_INVOICE_DATA';
export const SET_CALL_INVOICE_DATA = 'SET_CALL_INVOICE_DATA';

export const GET_CALL_INVOICE_VISIBILITY = 'GET_CALL_INVOICE_VISIBILITY';
export const SET_CALL_INVOICE_VISIBILITY = 'SET_CALL_INVOICE_VISIBILITY';

//* Rating 
export const GET_ASTROLOGER_RATING_VISIBILITY = 'GET_ASTROLOGER_RATING_VISIBILITY';
export const SET_ASTROLOGER_RATING_VISIBILITY = 'SET_ASTROLOGER_RATING_VISIBILITY';

//? Chat Request
export const REQUEST_INITIATED_BY_CUSTOMER = 'REQUEST_INITIATED_BY_CUSTOMER ';
export const REJECT_CHAT_BY_ASTROLOGER = 'REJECT_CHAT_BY_ASTROLOGER ';

//! Ecommerce
export const GET_SUGGESTED_PUJA = 'GET_SUGGESTED_PUJA';
export const SET_SUGGESTED_PUJA = 'SET_SUGGESTED_PUJA';
export const GET_PUJA = 'GET_PUJA';
export const SET_PUJA = 'SET_PUJA';
export const ADD_TO_CART = 'ADD_TO_CART';
export const GET_CART_DATA = 'GET_CART_DATA';
export const SET_CART_DATA = 'SET_CART_DATA';
export const UPDATE_CART_QUANTITY = 'UPDATE_CART_QUANTITY';
export const ORDER_CART = 'ORDER_CART';
export const REGISTER_CREATED_PUJA = 'REGISTER_CREATED_PUJA'; //* For Astrologers

//!Astromall
export const GET_ASTROMALL_DATA = 'GET_ASTRO_MALL_DATA'
export const SET_ASTROMALL_POOJA_DATA = 'SET_ASTROMALL_POOJA_DATA'
export const SET_ASTROMALL_SPELL_DATA = 'SET_ASTROMALL_SPELL_DATA'
export const GET_ASTROLOGER_POOJA_DATA = 'GET_ASTROLOGER_POOJA_DATA'
export const SET_ASTROLOGER_POOJA_DATA = 'SET_ASTROLOGER_POOJA_DATA'
export const ORDER_ASTROLOGER_POOJA = 'ORDER_ASTROLOGER_POOJA'
export const GET_ASTROMALL_HISTORY = 'GET_ASTROMALL_HISTORY'
export const SET_ASTROMALL_HISTORY = 'SET_ASTROMALL_HISTORY'

//! Blog
export const GET_ASTRO_BLOG_CATEGORY = 'GET_ASTRO_BLOG_CATEGORY';
export const SET_ASTRO_BLOG_CATEGORY = 'SET_ASTRO_BLOG_CATEGORY';
export const GET_ASTRO_BLOG = 'GET_ASTRO_BLOG';
export const SET_ASTRO_BLOG = 'SET_ASTRO_BLOG';
export const GET_ASTRO_BLOG_DETAILS = 'GET_ASTRO_BLOG_DETAILS';
export const SET_ASTRO_BLOG_DETAILS = 'SET_ASTRO_BLOG_DETAILS';
export const GET_RECENT_ASTRO_BLOG = 'GET_RECENT_ASTRO_BLOG';
export const SET_RECENT_ASTRO_BLOG = 'SET_RECENT_ASTRO_BLOG';
export const INCREMENT_ASTRO_BLOG_VIEW_COUNT = 'INCREMENT_ASTRO_BLOG_VIEW_COUNT';

//! Static Page
export const GET_TERMS_AND_CONDITION = 'GET_TERMS_AND_CONDITION';
export const SET_TERMS_AND_CONDITION = 'SET_TERMS_AND_CONDITION';
export const GET_PRIVACY_POLICY = 'GET_PRIVACY_POLICY';
export const SET_PRIVACY_POLICY = 'SET_PRIVACY_POLICY';
export const GET_ABOUT_US = 'GET_ABOUT_US';
export const SET_ABOUT_US = 'SET_ABOUT_US';

//! Profile
export const CREATE_KUNDLI_MATCHING_PROFILE = 'CREATE_KUNDLI_MATCHING_PROFILE';
export const GET_KUNDLI_MATCHING_PROFILE = 'GET_KUNDLI_MATCHING_PROFILE';
export const SET_KUNDLI_MATCHING_PROFILE = 'SET_KUNDLI_MATCHING_PROFILE';
export const GET_KUNDLI_MATCHING_PROFILE_BY_ID = 'GET_KUNDLI_MATCHING_PROFILE_BY_ID';
export const SET_KUNDLI_MATCHING_PROFILE_BY_ID = 'SET_KUNDLI_MATCHING_PROFILE_BY_ID';

//! Astrology API
//* Horoscope
export const GET_HOROSCOPE = 'GET_HOROSCOPE';
export const SET_HOROSCOPE = 'SET_HOROSCOPE';

//* Kundli Matching
export const GET_ASTHAKOOTA = 'GET_ASTHAKOOTA';
export const SET_ASTHAKOOTA = 'SET_ASTHAKOOTA';
export const GET_ASTRO_DATA = 'GET_ASTRO_DATA';
export const SET_ASTRO_DATA = 'SET_ASTRO_DATA';

//! Kundli
export const TOGGLE_KUNDLI_LOADER = 'TOGGLE_KUNDLI_LOADER';
export const GET_KUNDLI = 'GET_KUNDLI';
export const SET_KUNDLI = 'SET_KUNDLI';
export const CREATE_KUNDLI = 'CREATE_KUNDLI';
export const DELETE_KUNDLI = 'DELETE_KUNDLI';

export const KUNDLI_GET_BIRTH_DETAIL = 'KUNDLI_GET_BIRTH_DETAIL';
export const KUNDLI_SET_BIRTH_DETAIL = 'KUNDLI_SET_BIRTH_DETAIL';

export const KUNDLI_GET_ASTRO_DETAIL = 'KUNDLI_GET_ASTRO_DETAIL';
export const KUNDLI_SET_ASTRO_DETAIL = 'KUNDLI_SET_ASTRO_DETAIL';

export const KUNDLI_GET_FRIEND_SHIP_TABLE = 'KUNDLI_GET_FRIEND_SHIP_TABLE';
export const KUNDLI_SET_FRIEND_SHIP_TABLE = 'KUNDLI_SET_FRIEND_SHIP_TABLE';

export const KUNDLI_GET_KP_BIRTH_DETAIL = 'KUNDLI_GET_KP_BIRTH_DETAIL';
export const KUNDLI_SET_KP_BIRTH_DETAIL = 'KUNDLI_SET_KP_BIRTH_DETAIL';

export const KUNDLI_GET_KP_PLANETARY_POSITION = 'KUNDLI_GET_KP_PLANETARY_POSITION';
export const KUNDLI_SET_KP_PLANETARY_POSITION = 'KUNDLI_SET_KP_PLANETARY_POSITION';

export const KUNDLI_GET_KP_CUSPS_DETAIL = 'KUNDLI_GET_KP_CUSPS_DETAIL';
export const KUNDLI_SET_KP_CUSPS_DETAIL = 'KUNDLI_SET_KP_CUSPS_DETAIL';

export const KUNDLI_GET_KP_BIRTH_CHART = 'KUNDLI_GET_KP_BIRTH_CHART';
export const KUNDLI_SET_KP_BIRTH_CHART = 'KUNDLI_SET_KP_BIRTH_CHART';

export const KUNDLI_GET_KP_CUSPS_CHART = 'KUNDLI_GET_KP_CUSPS_CHART';
export const KUNDLI_SET_KP_CUSPS_CHART = 'KUNDLI_SET_KP_CUSPS_CHART';

export const KUNDLI_GET_KP_PLANET_SIGNIFICATOR = 'KUNDLI_GET_KP_PLANET_SIGNIFICATOR';
export const KUNDLI_SET_KP_PLANET_SIGNIFICATOR = 'KUNDLI_SET_KP_PLANET_SIGNIFICATOR';

export const KUNDLI_GET_KP_HOUSE_SIGNIFICATOR = 'KUNDLI_GET_KP_HOUSE_SIGNIFICATOR';
export const KUNDLI_SET_KP_HOUSE_SIGNIFICATOR = 'KUNDLI_SET_KP_HOUSE_SIGNIFICATOR';

export const KUNDLI_GET_KP_RULING_PLANET = 'KUNDLI_GET_KP_RULING_PLANET';
export const KUNDLI_SET_KP_RULING_PLANET = 'KUNDLI_SET_KP_RULING_PLANET';

export const KUNDLI_GET_PLANETARY_POSITION = 'KUNDLI_GET_PLANETARY_POSITION';
export const KUNDLI_SET_PLANETARY_POSITION = 'KUNDLI_SET_PLANETARY_POSITION';

export const KUNDLI_GET_UPGRAHA = 'KUNDLI_GET_UPGRAHA';
export const KUNDLI_SET_UPGRAHA = 'KUNDLI_SET_UPGRAHA';

export const KUNDLI_GET_DASHAM_BHAV_MADHYA = 'KUNDLI_GET_DASHAM_BHAV_MADHYA';
export const KUNDLI_SET_DASHAM_BHAV_MADHYA = 'KUNDLI_SET_DASHAM_BHAV_MADHYA';

export const KUNDLI_GET_ASHTAK_VARGA = 'KUNDLI_GET_ASHTAK_VARGA';
export const KUNDLI_SET_ASHTAK_VARGA = 'KUNDLI_SET_ASHTAK_VARGA';

export const KUNDLI_GET_SARVASHTAK = 'KUNDLI_GET_SARVASHTAK';
export const KUNDLI_SET_SARVASHTAK = 'KUNDLI_SET_SARVASHTAK';

export const KUNDLI_GET_VIMSHOTTARI_DASHA = 'KUNDLI_GET_VIMSHOTTARI_DASHA';
export const KUNDLI_SET_VIMSHOTTARI_DASHA = 'KUNDLI_SET_VIMSHOTTARI_DASHA';

export const KUNDLI_GET_VIMSHOTTARI_CURRENT_DASHA = 'KUNDLI_GET_VIMSHOTTARI_CURRENT_DASHA';
export const KUNDLI_SET_VIMSHOTTARI_CURRENT_DASHA = 'KUNDLI_SET_VIMSHOTTARI_CURRENT_DASHA';

export const KUNDLI_GET_YOGINI_DASHA = 'KUNDLI_GET_YOGINI_DASHA';
export const KUNDLI_SET_YOGINI_DASHA = 'KUNDLI_SET_YOGINI_DASHA';

export const KUNDLI_GET_YOGINI_CURRENT_DASHA = 'KUNDLI_GET_YOGINI_CURRENT_DASHA';
export const KUNDLI_SET_YOGINI_CURRENT_DASHA = 'KUNDLI_SET_YOGINI_CURRENT_DASHA';

export const KUNDLI_GET_JAIMINI_DETAILS = 'KUNDLI_GET_JAIMINI_DETAILS';
export const KUNDLI_SET_JAIMINI_DETAILS = 'KUNDLI_SET_JAIMINI_DETAILS';

export const KUNDLI_GET_CHAR_DASHA = 'KUNDLI_GET_CHAR_DASHA';
export const KUNDLI_SET_CHAR_DASHA = 'KUNDLI_SET_CHAR_DASHA';

export const KUNDLI_GET_CHAR_CURRENT_DASHA = 'KUNDLI_GET_CHAR_CURRENT_DASHA';
export const KUNDLI_SET_CHAR_CURRENT_DASHA = 'KUNDLI_SET_CHAR_CURRENT_DASHA';

export const KUNDLI_GET_NUMEROLOGY_DETAILS = 'KUNDLI_GET_NUMEROLOGY_DETAILS';
export const KUNDLI_SET_NUMEROLOGY_DETAILS = 'KUNDLI_SET_NUMEROLOGY_DETAILS';

export const KUNDLI_GET_MANGAL_DOSHA = 'KUNDLI_GET_MANGAL_DOSHA';
export const KUNDLI_SET_MANGAL_DOSHA = 'KUNDLI_SET_MANGAL_DOSHA';

export const KUNDLI_GET_KAALSARP_DOSHA = 'KUNDLI_GET_KAALSARP_DOSHA';
export const KUNDLI_SET_KAALSARP_DOSHA = 'KUNDLI_SET_KAALSARP_DOSHA';

export const KUNDLI_GET_PITRI_DOSHA = 'KUNDLI_GET_PITRI_DOSHA';
export const KUNDLI_SET_PITRI_DOSHA = 'KUNDLI_SET_PITRI_DOSHA';

export const KUNDLI_GET_SADHE_SATI = 'KUNDLI_GET_SADHE_SATI';
export const KUNDLI_SET_SADHE_SATI = 'KUNDLI_SET_SADHE_SATI';

export const KUNDLI_GET_PREDICTION = 'KUNDLI_GET_PREDICTION';
export const KUNDLI_SET_PREDICTION = 'KUNDLI_SET_PREDICTION';

export const KUNDLI_GET_LAGNA_CHART = 'KUNDLI_GET_LAGNA_CHART';
export const KUNDLI_SET_LAGNA_CHART = 'KUNDLI_SET_LAGNA_CHART';

export const KUNDLI_GET_MOON_CHART = 'KUNDLI_GET_MOON_CHART';
export const KUNDLI_SET_MOON_CHART = 'KUNDLI_SET_MOON_CHART';

export const KUNDLI_GET_SUN_CHART = 'KUNDLI_GET_SUN_CHART';
export const KUNDLI_SET_SUN_CHART = 'KUNDLI_SET_SUN_CHART';

export const KUNDLI_GET_CHALIT_CHART = 'KUNDLI_GET_CHALIT_CHART';
export const KUNDLI_SET_CHALIT_CHART = 'KUNDLI_SET_CHALIT_CHART';

export const KUNDLI_GET_HORA_CHART = 'KUNDLI_GET_HORA_CHART';
export const KUNDLI_SET_HORA_CHART = 'KUNDLI_SET_HORA_CHART';

export const KUNDLI_GET_DRESHKAN_CHART = 'KUNDLI_GET_DRESHKAN_CHART';
export const KUNDLI_SET_DRESHKAN_CHART = 'KUNDLI_SET_DRESHKAN_CHART';

export const KUNDLI_GET_NAVAMANSHA_CHART = 'KUNDLI_GET_NAVAMANSHA_CHART';
export const KUNDLI_SET_NAVAMANSHA_CHART = 'KUNDLI_SET_NAVAMANSHA_CHART';

export const KUNDLI_GET_DASHAMANSHA_CHART = 'KUNDLI_GET_DASHAMANSHA_CHART';
export const KUNDLI_SET_DASHAMANSHA_CHART = 'KUNDLI_SET_DASHAMANSHA_CHART';

export const KUNDLI_GET_DWADASMANSHA_CHART = 'KUNDLI_GET_DWADASMANSHA_CHART';
export const KUNDLI_SET_DWADASMANSHA_CHART = 'KUNDLI_SET_DWADASMANSHA_CHART';

export const KUNDLI_GET_TRISHAMANSHA_CHART = 'KUNDLI_GET_TRISHAMANSHA_CHART';
export const KUNDLI_SET_TRISHAMANSHA_CHART = 'KUNDLI_SET_TRISHAMANSHA_CHART';

export const KUNDLI_GET_SHASHTYMANSHA_CHART = 'KUNDLI_GET_SHASHTYMANSHA_CHART';
export const KUNDLI_SET_SHASHTYMANSHA_CHART = 'KUNDLI_SET_SHASHTYMANSHA_CHART';